/*
 * wim-analytics-ecommerce.js
 *
 * Traduce las interacciones de compra del tema a eventos de dataLayer.
 *
 * Fuentes de datos:
 *  - Ficha y parrilla: JSON serializado en el servidor (#wim-analytics-data).
 *  - Adición al carrito: respuesta de /cart/add, que devuelve la línea añadida
 *    con identificadores y precio reales.
 *  - Carrito lateral y vista rápida: eventos propios del tema base.
 *
 * El checkout y la compra NO se miden aquí: viven en el píxel de Customer Events.
 */

(function () {
  'use strict';

  var INIT_FLAG = 'wimAnalyticsEcommerceInit';
  if (window[INIT_FLAG]) return;
  window[INIT_FLAG] = true;

  var dl = (window.dataLayer = window.dataLayer || []);

  /* Contexto publicado por wim-analytics-context.liquid */
  function context() {
    return window.wimAnalyticsContext || {};
  }

  /* Los eventos propios se publican con prefijo para no colisionar con los
     que emite el canal de Google. El nombre estándar se aplica en la etiqueta,
     al enviar a la analítica. El objeto de comercio electrónico se limpia antes
     de cada envío para que no arrastre valores del mensaje anterior. */
  function push(name, payload) {
    dl.push({ ecommerce: null });
    dl.push(Object.assign({ event: 'wim_' + name, wim_source: 'theme' }, context(), payload || {}));
  }

  /* Datos serializados en el servidor; devuelve un objeto vacío si no existen */
  var DATA = (function () {
    var node = document.getElementById('wim-analytics-data');
    if (!node) return {};
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return {};
    }
  })();

  var CURRENCY = DATA.currency || 'EUR';

  function value(items) {
    return items.reduce(function (sum, i) {
      return sum + (Number(i.price) || 0) * (Number(i.quantity) || 1);
    }, 0);
  }

  /* ── Vistas ───────────────────────────────────────────────────────────── */

  if (DATA.item) {
    push('view_item', {
      ecommerce: { currency: CURRENCY, value: DATA.item.price, items: [DATA.item] }
    });
  }

  if (DATA.items && DATA.items.length) {
    push('view_item_list', {
      ecommerce: {
        item_list_id: DATA.list_id,
        item_list_name: DATA.list_name,
        items: DATA.items
      }
    });
  }

  /* ── Clic en tarjeta de producto ──────────────────────────────────────── */

  /* Resuelve el handle de producto a partir de una URL de ficha */
  function handleFromUrl(url) {
    var match = String(url).match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href*="/products/"]');
    if (!link || !DATA.items || !DATA.items.length) return;

    var handle = handleFromUrl(link.getAttribute('href'));
    if (!handle) return;

    var item = DATA.items.filter(function (i) { return i.item_handle === handle; })[0];
    if (!item) return;

    push('select_item', {
      ecommerce: {
        item_list_id: DATA.list_id,
        item_list_name: DATA.list_name,
        items: [item]
      }
    });
  });

  /* ── Adición al carrito ───────────────────────────────────────────────── */

  /* Normaliza la línea devuelta por /cart/add al formato de artículo de GA4 */
  function lineToItem(line) {
    return {
      item_id: line.sku || String(line.variant_id || line.id),
      item_variant_id: line.variant_id || line.id,
      item_name: line.product_title || line.title,
      item_brand: line.vendor,
      item_category: line.product_type,
      item_variant: line.variant_title || undefined,
      item_handle: line.handle,
      price: typeof line.final_price === 'number'
        ? line.final_price / 100
        : (typeof line.price === 'number' ? line.price / 100 : undefined),
      quantity: line.quantity || 1
    };
  }

  function onCartAdd(body, source) {
    if (!body) return;
    var lines = Array.isArray(body.items) ? body.items : [body];
    var items = lines.filter(Boolean).map(lineToItem);
    if (!items.length) return;

    push('add_to_cart', {
      add_source: source || 'unknown',
      ecommerce: { currency: CURRENCY, value: value(items), items: items }
    });
  }

  function isCartAdd(url) {
    try {
      return new URL(url, window.location.origin).pathname.indexOf('/cart/add') !== -1;
    } catch (e) {
      return String(url).indexOf('/cart/add') !== -1;
    }
  }

  /* Origen probable de la adición, para separar ficha de parrilla en informes */
  function addSource() {
    var active = document.activeElement;
    if (active && active.closest && active.closest('[data-wim-quick-add], quick-add-product')) {
      return 'quick_add';
    }
    return DATA.item ? 'pdp' : 'grid';
  }

  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var source = addSource();
      return nativeFetch.apply(this, arguments).then(function (response) {
        if (url && isCartAdd(url) && response.ok) {
          response.clone().json().then(function (body) { onCartAdd(body, source); }).catch(function () {});
        }
        return response;
      });
    };
  }

  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__wimCartAdd = isCartAdd(url);
    if (this.__wimCartAdd) {
      var source = addSource();
      this.addEventListener('load', function () {
        if (this.status < 200 || this.status >= 300) return;
        try { onCartAdd(JSON.parse(this.responseText), source); } catch (e) {}
      });
    }
    return nativeOpen.apply(this, arguments);
  };

  /* ── Interacciones del tema ───────────────────────────────────────────── */

  document.addEventListener('theme:cart-drawer:open', function () {
    push('view_cart', {});
  });

  document.addEventListener('theme:quick-add:open', function () {
    push('quick_view', {});
  });
})();
